<template>
  <div>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="exports"
        :options.sync="options"
        :server-items-length="totalExports"
        :loading="loading"
        :footer-props="{ 'items-per-page-options': [5, 10, 20, 50, 100] }"
      >
        <template #item.actions="{ item }">
          <v-btn color="primary" @click="goToDetails(item.id)" small icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="error" @click="openDeleteDialog(item)" small icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card>
          <v-card-title>{{ $t('confirmDeleteTitle') }}</v-card-title>
          <v-card-text>{{ $t('confirmDeleteExport') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="deleteDialog = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="error"
              text
              @click="deleteExport(selectedItem?.id)"
              :disabled="!selectedItem"
            >
              {{ $t('confirmDeletion') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import ExportsService from '@/services/ExportsService'

export default {
  data() {
    return {
      headers: [
        { text: this.$t('name'), value: 'name', sortable: false },
        { text: this.$t('creationDate'), value: 'created_at', sortable: false },
        { text: this.$t('actions'), value: 'actions', sortable: false },
      ],
      exports: [],
      totalExports: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      loading: false,
      deleteDialog: false,
      selectedItem: null,
    }
  },
  props: {
    fetchMethod: {
      type: Function,
    },
    detailsRoute: {
      type: String,
      default: 'ExportDetails',
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchExports()
      },
      deep: true,
    },
  },
  methods: {
    async fetchExports() {
      this.loading = true
      try {
        const { page, itemsPerPage } = this.options
        const response = await this.fetchMethod(page, itemsPerPage)
        const data = response.data
        this.exports = data.results.map((exp) => ({
          id: exp.id,
          name: exp.name,
          created_at: exp.created_at,
        }))
        this.totalExports = data.count
      } catch (error) {
        console.error('Failed to fetch exports:', error)
      } finally {
        this.loading = false
        this.$emit('loaded')
      }
    },
    async exportService(method, ...rest) {
      const result = await ExportsService[
        method + (this.isAdmin ? 'Admin' : '')
      ](this, ...rest)

      if (result?.status) return true
      throw new Error("Couldn't fetch data.")
    },
    async deleteExport(exportId) {
      this.deleteDialog = false
      await this.exportService('deleteExport', exportId)

      if (
        this.totalExports % this.options.itemsPerPage === 1 &&
        this.options.page > 1
      ) {
        this.options.page -= 1
      } else {
        this.fetchExports()
      }
    },
    goToDetails(exportId) {
      this.$router.push({ name: this.detailsRoute, params: { id: exportId } })
    },
    openDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialog = true
    },
  },
}
</script>
